import { E_APP_ENV } from 'src/config-global';

/**
 * Customer Care suite (Twilio / Patients / Inbox / Campaigns) is still WIP / mock-backed.
 * Visible ONLY when `VITE_APP_ENV === 'dev'` — never on staging or production releases.
 *
 * Guards:
 * - Navbar: Inbox + Campaigns items
 * - Routes: /inbox, /campaigns, patient-feedback
 * - Suggestion board: Twilio / add-patient / start-campaign cards
 * - Sidebar: Dedicated Number widget
 * - Hooks: all Customer Care queries are disabled when this returns false
 */
export function isCustomerCareEnabled(): boolean {
  return import.meta.env.VITE_APP_ENV === E_APP_ENV.DEV;
}
